
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/AdvancedTopics/ImpactLevels",
      function () {
        return require("private-next-pages/docs/UserDocs/AdvancedTopics/ImpactLevels.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/AdvancedTopics/ImpactLevels"])
      });
    }
  